// sections/DetailCustomerSection.tsx

import { useReceivableDetail } from "../../hooks/useReceivableDetail";

const DetailCustomerSection = () => {
  const { detail } = useReceivableDetail();

  if (!detail) return null;

  const customer = detail.customer;

  return (
    <section
      className="
        rounded-xl
        border border-stroke
        bg-white
        p-6
        shadow-default
        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      <h4 className="mb-5 text-base font-semibold text-black dark:text-white">
        Información del Cliente
      </h4>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        {/* Cliente */}
        <div className="rounded-lg border border-gray bg-gray-2 p-4 dark:border-strokedark dark:bg-boxdark-2">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Cliente
          </p>

          <p className="font-semibold text-black dark:text-white">
            {customer?.name || "-"}
          </p>
        </div>

        {/* Código Cliente */}
        <div className="rounded-lg border border-gray bg-gray-2 p-4 dark:border-strokedark dark:bg-boxdark-2">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Código Cliente
          </p>

          <p className="font-semibold text-black dark:text-white">
            CLI-{String(customer?.id || 0).padStart(4, "0")}
          </p>
        </div>

        {/* Teléfono */}
        <div className="rounded-lg border border-gray bg-gray-2 p-4 dark:border-strokedark dark:bg-boxdark-2">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Teléfono
          </p>

          <p className="font-semibold text-black dark:text-white">
            {customer?.phone || "No registrado"}
          </p>
        </div>

        {/* Correo */}
        <div className="rounded-lg border border-primary/20 bg-primary/5 p-4 dark:border-primary/30 dark:bg-primary/10">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Correo
          </p>

          <p className="font-medium text-black dark:text-white">
            {customer?.email || "No registrado"}
          </p>
        </div>

        {/* Dirección */}
        <div className="rounded-lg border border-gray bg-gray-2 p-4 dark:border-strokedark dark:bg-boxdark-2 md:col-span-2">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Dirección
          </p>

          <p className="font-semibold text-black dark:text-white">
            {customer?.address || "No registrada"}
          </p>
        </div>

        {/* DUI */}
        <div className="rounded-lg border border-gray bg-gray-2 p-4 dark:border-strokedark dark:bg-boxdark-2">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            DUI
          </p>

          <p className="font-semibold text-black dark:text-white">
            {customer?.dui || "No registrado"}
          </p>
        </div>

        {/* NIT */}
        <div className="rounded-lg border border-gray bg-gray-2 p-4 dark:border-strokedark dark:bg-boxdark-2">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            NIT
          </p>

          <p className="font-semibold text-black dark:text-white">
            {customer?.nit || "No registrado"}
          </p>
        </div>

        {/* NRC */}
        <div className="rounded-lg border border-gray bg-gray-2 p-4 dark:border-strokedark dark:bg-boxdark-2">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            NRC
          </p>

          <p className="font-semibold text-black dark:text-white">
            {customer?.nrc || "No registrado"}
          </p>
        </div>

        {/* Razón Social */}
        <div className="rounded-lg border border-gray bg-gray-2 p-4 dark:border-strokedark dark:bg-boxdark-2">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Razón Social
          </p>

          <p className="font-semibold text-black dark:text-white">
            {customer?.legalName || "No registrada"}
          </p>
        </div>

        {/* Nombre Comercial */}
        <div className="rounded-lg border border-gray bg-gray-2 p-4 dark:border-strokedark dark:bg-boxdark-2 md:col-span-2">
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Nombre Comercial
          </p>

          <p className="font-semibold text-black dark:text-white">
            {customer?.tradeName || "No registrado"}
          </p>
        </div>
      </div>
    </section>
  );
};

export default DetailCustomerSection;